


























import Vue, { PropType } from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { ResponsiveImageInterface } from '../../common/vue/ResponsiveImage.vue';
import { ExpandedMediaEventBusEvents, ExpandedMediaEventBus } from './ExpandedMediaEventBus';

const IconExpand = () => import('../../common/icons/expand.svg');
const IconPlayCircle = () => import('../../common/icons/play-circle.svg');
const PlayOnYoutubeButton = () => import('../../common/vue/play-on-youtube-button/PlayOnYoutubeButton.vue');

const ExpandMediaProps = Vue.extend({
  props: {
    expanded: Boolean,
    pictureJson: String,
    pictureObject: Object as PropType<ResponsiveImageInterface>,
    desktopVideo: String,
    tabletVideo: String,
    mobileVideo: String,
    youTubeId: String,
    videoLength: String,
    trackingName: {
      type: String,
      default: 'imagefullscreen',
    },
    iconPosition: {
      type: String,
      default: 'left-container',
    },
    loopVideo: Boolean,
    muteVideo: Boolean,
    showControls: Boolean,
    showControlsNative: Boolean,
    showIcon: {
      type: Boolean,
      default: true,
    },
  },
});

@Component({
  components: {
    PlayOnYoutubeButton,
    IconExpand,
    IconPlayCircle,
  },
})
export default class ExpandMedia extends ExpandMediaProps {
  $refs!: {
    expandSurface: HTMLElement;
  }

  mousedownX: number | null = null;
  mousedownY: number | null = null;

  get rootClass () {
    return {
      'brandhub-expand-media--desktop-video': this.desktopVideo,
      'brandhub-expand-media--youtube-video': this.youTubeId,
    };
  }

  @Watch('expanded')
  onExpandedChange (value: boolean) {
    if (value) {
      this.expandMedia();
    } else {
      ExpandedMediaEventBus.$emit(ExpandedMediaEventBusEvents.Close);
      this.onClose();
    }
  }

  created () {
    ExpandedMediaEventBus.$on(ExpandedMediaEventBusEvents.ClosingFinished, this.onClose);
  }

  handleMousedown (event: MouseEvent) {
    this.mousedownX = event.clientX;
    this.mousedownY = event.clientY;
  }

  onClick (event: MouseEvent) {
    // dragged, not clicked!
    if (this.mousedownX && this.mousedownY && (Math.abs(this.mousedownX - event.clientX) > 5 || Math.abs(this.mousedownY - event.clientY) > 5)) {
      return;
    }
    this.expandMedia();

    // this is needed for autoplay on click
    setTimeout(() => {
      ExpandedMediaEventBus.$emit(ExpandedMediaEventBusEvents.Play);
    }, 500);
  }

  expandMedia () {
    const expandedMedia = document.createElement('brandhub-expanded-media');
    if (this.pictureString) {
      expandedMedia.setAttribute('picture-json', this.pictureString);
    } else if (this.youTubeId) {
      expandedMedia.setAttribute('you-tube-id', this.youTubeId);
    } else {
      expandedMedia.setAttribute('desktop-video', this.desktopVideo);
      expandedMedia.setAttribute('tablet-video', this.tabletVideo);
      expandedMedia.setAttribute('mobile-video', this.mobileVideo);
      expandedMedia.setAttribute('loop-video', this.loopVideo ? 'true' : 'false');
      expandedMedia.setAttribute('mute-video', this.muteVideo ? 'true' : 'false');
      expandedMedia.setAttribute('show-controls', this.showControls ? 'true' : 'false');
      expandedMedia.setAttribute('show-controls-native', this.showControlsNative ? 'true' : 'false');
    }
    expandedMedia.setAttribute('tracking-name', this.trackingName);

    const boundingElement = this.$refs.expandSurface.getBoundingClientRect();
    expandedMedia.setAttribute('origin-x', boundingElement.left.toString());
    expandedMedia.setAttribute('origin-y', boundingElement.top.toString());
    expandedMedia.setAttribute('origin-width', boundingElement.width.toString());
    expandedMedia.setAttribute('origin-height', boundingElement.height.toString());

    document.body.appendChild(expandedMedia);
  }

  onClose () {
    this.$emit('close');
  }

  get pictureString () {
    if (this.pictureJson) {
      return this.pictureJson;
    }
    if (this.pictureObject) {
      return JSON.stringify(this.pictureObject);
    }
    return null;
  }

  get isVideo () {
    return this.desktopVideo || this.youTubeId;
  }

  get buttonClass () {
    return {
      'brandhub-expand-media__expand-button--video': this.isVideo,
      'brandhub-expand-media__expand-button--image': !this.isVideo,
      'brandhub-expand-media__expand-button--left-container': this.iconPosition === 'left-container',
      'brandhub-expand-media__expand-button--center': this.iconPosition === 'center',
      'brandhub-expand-media__expand-button--right': this.iconPosition === 'right',
    };
  }
}
